import { render, staticRenderFns } from "./GiftCardAssignTaskConfigPane.vue?vue&type=template&id=8840e0fc&scoped=true"
import script from "./GiftCardAssignTaskConfigPane.vue?vue&type=script&lang=js"
export * from "./GiftCardAssignTaskConfigPane.vue?vue&type=script&lang=js"
import style0 from "./GiftCardAssignTaskConfigPane.vue?vue&type=style&index=0&id=8840e0fc&lang=css"
import style1 from "./GiftCardAssignTaskConfigPane.vue?vue&type=style&index=1&id=8840e0fc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8840e0fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8840e0fc')) {
      api.createRecord('8840e0fc', component.options)
    } else {
      api.reload('8840e0fc', component.options)
    }
    module.hot.accept("./GiftCardAssignTaskConfigPane.vue?vue&type=template&id=8840e0fc&scoped=true", function () {
      api.rerender('8840e0fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/gift_card/GiftCardAssignTaskConfigPane.vue"
export default component.exports